// /src/shared/lib/file.ts

/**
 * Скачивает файл из Base64-строки
 * @param base64    — Base64-контент без префикса data:…
 * @param mimeType  — MIME‑тип, например "image/png"
 * @param filename  — имя сохраняемого файла, например "receipt.png"
 */

export function downloadBase64File({
  base64,
  mimeType,
  filename,
}: {
  base64: string
  mimeType: string
  filename: string
}): void {
  try {
    const byteCharacters = atob(base64)
    const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0))
    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], { type: mimeType })

    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = filename
    link.click()
    URL.revokeObjectURL(link.href)
  } catch (error) {
    console.error('Ошибка при скачивании файла:', error)
  }
}

/**
 * Вычисляет размер Base64-строки в байтах
 */
export function getBase64FileSize(base64: string): number {
  const padding = base64.match(/=+$/)?.[0].length ?? 0
  const sizeInBytes = (base64.length * 3) / 4 - padding
  return Math.round(sizeInBytes)
}

/**
 * Преобразует число байт в человекочитаемый формат
 */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(0)} MB`
}

export function getLinkName(mimeType: string) {
  const format = mimeType.split('/')?.[1] || 'unknown'

  return `Документ.${format}`
}
